export const BIV1 = [
  "propertiesCompletedWithinLast36Months",
  "foreignNational",
  "ImmigrationStatus",
  "originalCreditScore",
  "InState",
];

export const quickLoanBIV1 = [
  "borrowerType",
  "citizenshipStatus",
  "creditScoreActual",
  "creditReportDate",
  "borrowingEntityName",
  "borrowerEmail",
  "borrowerName",
  "guarantorName",
  "guarantorEmail",
];

export const detailedLoanBIV1 = [
  "borrowerType",
  "creditScoreActual",
  "creditReportDate",
  "citizenshipStatus",
  "FirstTimeHomeBuyer"
];

export const detailedLoanBIV2 = [
  "borrowerType",
  "creditScoreActual",
  "creditReportDate",
  "citizenshipStatus",
  "borrowingEntityName",
  "borrowerName",
  "borrowerEmail",
  "guarantorName",
  "guarantorEmail",
  "FirstTimeHomeBuyer",
];